export default __webpack_public_path__ + "static/media/Foot & Ankle Disability Index FADI.9703abf0.pdf";